export default __webpack_public_path__ + "static/link-label-dont-71302ab16d26745cb9b1178ef2370bd6c3513e2a54f7ddccd2f8964b0e405ebf.png";